import type { LeadFlag } from '@/types/crm'

/**
 * Banners at the very top of the lead, above the stepper.
 *
 * Placed first deliberately. A `critical` flag means the company must not be
 * contacted at all — that has to be visible before the rep reads the playbook
 * card, not buried in the activity log below it.
 */
export function LeadFlags({ flags }: { flags: LeadFlag[] }) {
  if (flags.length === 0) return null

  return (
    <div className="flags">
      {flags.map((f, i) => (
        <div
          key={`${f.level}-${i}`}
          className={`flag flag--${f.level}`}
          role={f.level === 'critical' ? 'alert' : undefined}
        >
          <span className="flag__label">{f.label}</span>
          <span className="flag__text">{f.text}</span>
        </div>
      ))}
    </div>
  )
}
